import React, { useEffect } from 'react'

const WlDeftform = ({ formId, prefillEmail = '' }) => {
    const emailFieldIdentifier = process.env.REACT_APP_DEFTFORM_EMAIL_FIELD_IDENTIFIER || 'email';
    const prefillQuery = prefillEmail
        ? new URLSearchParams({ [emailFieldIdentifier]: prefillEmail }).toString()
        : '';

    useEffect(() => {
        const existingScript = document.getElementById('deftform-script');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = "https://cdn.deftform.com/embed.js";
            script.async = true;
            script.id = 'deftform-script'
            document.body.appendChild(script);
        }
    }, [])

    useEffect(() => {
        if (!prefillQuery || typeof window.reinitDeftform !== 'function') return;
        window.reinitDeftform();
    }, [prefillQuery]);

    return (
        <div>
            <div className="deftform" 
                data-form-id={formId} 
                data-form-width="100%" 
                data-form-height="800px" 
                data-form-auto-height="1"
                data-form-prefill={prefillQuery}>
            </div>
        </div>
    )
}

export default WlDeftform;
